import { Routes, Route } from "react-router-dom";
import { Suspense } from "react";

import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import LogoutPage from "./pages/Logout/Logout";
import ProtectedRoutes from "./components/ProtectedRoute/ProtectedRoute";
import CategoriesPage from "./pages/Categories/Categories";
import SettingsPage from "./pages/Settings/SettingsPage";
import PaymentMethodsPage from "./pages/PaymentMethods/PaymentMethods";
import ProfilePage from "./pages/Profile/ProfilePage";
import AccountsPage from "./pages/Accounts/AccountsPage";
import VoiceAssistantsPage from "./pages/VoiceAssistants/VoiceAssistantsPage";

import Reports from "./pages/Transactions/Reports";
import PasswordRecoveryPage from "./pages/PasswordRecovery/PasswordRecoveryPage";
import NewAccountPage from "./pages/NewAccount/NewAccountPage";
import CategoryPage from "./pages/Categories/EditCategoryPage";
import ResetCachePage from "./pages/ResetCachePage/ResetCachePage";
import TransactionsColorsPage from "./pages/Colors/TransactionsColors";
import RecurringTransactionsPage from "./pages/RecurringTransactionsPage/RecurringTransactionsPage";
import SourcesPage from "./pages/Sources/SourcesPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";
import TermsAndConditionsPage from "./pages/TermsAndConditionsPage/TermsAndConditionsPage";
import HelpCenterPage from "./pages/HelpCenterPage/HelpCenterPage";
import NewTransactionPage from "./pages/NewTransaction/NewTransactionPage";
import NotFound404 from "./pages/NotFound404/NotFound404";
import RegisterAccountPage from "./pages/RegisterAccount/RegisterAccount";
import LoginPage from "./pages/Login/Login";
import Transactions from "./pages/Transactions/Transactions";
import AttachmentsPage from "./pages/AttachmentsPage/AttachmentsPage";
import EditSourcePage from "./pages/Sources/EditSourcePage";
import NotificationsPage from "./pages/NotificationsPage/NotificationsPage";
import MyNetworkPage from "./pages/MyNetwork/MyNetworkPage";
import LoadingWithTextPage from "./components/LoadingWithText/LoadingWithTextPage";

export const LeRoutes: React.FC = () => {
  return (
    <>
      <ScrollToTop />

      <Suspense fallback={<LoadingWithTextPage />}>
        <Routes>
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditionsPage />}
          />

          <Route element={<ProtectedRoutes />}>
            <Route path="/settings/cache" element={<ResetCachePage />} />
            <Route
              path="/recurring/:account?"
              element={<RecurringTransactionsPage />}
            />
            <Route path="/notifications" element={<NotificationsPage />} />

            <Route
              path="/settings/voice-assistants"
              element={<VoiceAssistantsPage />}
            />

            <Route
              path="/settings/colors"
              element={<TransactionsColorsPage />}
            />
            {/* 
            <Route
              path="/invites"
              element={<Navigate replace to="/contacts" />}
            /> */}

            <Route path="/settings/contacts" element={<MyNetworkPage />} />
            <Route path="/settings/help" element={<HelpCenterPage />} />

            <Route
              path="/shared-transactions"
              element={<RecurringTransactionsPage />}
            />
            {/* <Route path="/notes" element={<NotesPage />} />
            <Route path="/notes/:noteId" element={<NotePage />} /> */}

            <Route path="/reports/:account?" element={<Reports />} />

            <Route path="/settings/" element={<SettingsPage />} />

            <Route path="/settings/accounts" element={<AccountsPage />} />
            <Route path="/settings/accounts/new" element={<NewAccountPage />} />
            <Route
              path="/settings/accounts/:accountId"
              element={<NewAccountPage editMode />}
            />

            <Route path="/settings/categories" element={<CategoriesPage />} />
            <Route path="/settings/sources" element={<SourcesPage />} />

            <Route
              path="/settings/categories/:category"
              element={<CategoryPage />}
            />
            <Route
              path="/settings/sources/:source"
              element={<EditSourcePage />}
            />

            {/* <Route path="/settings/profile" element={<SettingsPage />} /> */}
            <Route
              path="/settings/payment-methods"
              element={<PaymentMethodsPage />}
            />
            <Route path="/settings/profile" element={<ProfilePage />} />

            <Route path="/transactions/:account?" element={<Transactions />} />
            {/* <Route path="/summary/:account?" element={<SummaryPage />} /> */}
            <Route
              path="/attachments/:account?"
              element={<AttachmentsPage />}
            />

            <Route
              path="/transaction/:account?/:transaction?"
              element={<NewTransactionPage />}
            />

            <Route path="/logout" element={<LogoutPage />} />
            <Route path="/404" element={<NotFound404 />} />
            <Route path="*" element={<NotFound404 />} />
          </Route>
          <Route path="/password-recovery" element={<PasswordRecoveryPage />} />

          <Route path="/register" element={<RegisterAccountPage />} />

          <Route path="/" element={<LoginPage />} />
        </Routes>
      </Suspense>
    </>
  );
};

export default LeRoutes;
